import React from 'react';
import Images from '../assets/AllImages';

const PerformanceCards = [
    { image: Images.Performace1 },
    { image: Images.Performace2 },
    { image: Images.Performace3 },
    { image: Images.Performace4 }
];

const RESTURANT = () => {
    return (
        <>
            <main>
                <div className="container-fluid bg-primary py-3 py-md-0">
                    <div className="row  align-items-center">
                        <div className="col-12 col-md-6 px-5">
                            <h5 className='text-white fw-bold my-0'>HOTEL & RESTURANT</h5>
                        </div>

                        <div className="col-12 col-md-6 px-5 d-none d-sm-block">
                            <img src={Images.Vactor2} alt="" className='w-50 float-end' />
                        </div>
                    </div>
                </div>
            </main>

            {/* Create a Banner Section */}
            <div className="container-fluid resturant-banner text-center text-white">
                <div className="col-md-8">
                    <h3 className='fw-bold py-3'>Comfort, Energy, and Nutrition — All in One Place</h3>
                    <p className='fw-bold'>A World-Class Aquatic Experience Under the Open Sky</p>
                    <p className='fs-6'>Located at the heart of the Step Arena complex, our hotel offers a seamless blend of comfort, function, and proximity to world-class sports facilities. Whether you're an athlete preparing for a major event, a coach organizing a training camp, or a family looking for an active getaway, the Step Arena Hotel is designed to meet your every need.</p>
                </div>
            </div>

            {/* Create Modren Room Section */}
            <div className="container-fluid">
                <div className="row py-5">
                    <div className="col-md-8 text-center mx-auto">
                        <h4 className='text-primary fw-bold'>Where Performance Meets Nutrition</h4>
                        <p>The Step Arena Restaurant fuels your goals with a carefully crafted menu that blends flavor, health, and performance. From high-protein options for athletes to balanced meals for families and children, every dish is designed to nourish and energize.</p>
                        <p>Our kitchen sources fresh ingredients and offers tailored nutritional support for different dietary needs. Whether you’re recovering after training or enjoying a relaxed meal with loved ones, you’ll find the perfect choice in a warm, welcoming environment.</p>
                    </div>
                </div>

                <div className="row">

                    <div className="container-fluid p-0 position-relative">
                        

                        <div className="container position-absolute start-50 translate-middle-x icon-card">

                            <div className="row justify-content-center">

                                {PerformanceCards.map((item, index) => (

                                    <div key={index} className="col-3 d-flex flex-column align-items-center text-center">

                                        <div className="bg-white py-md-4 rounded w-100 h-100 shadow icon-container bg-primary">
                                            <img src={item.image} alt="" className="img-fluid my-3" />
                                            <p className='text-primary'>Trainer</p>
                                        </div>

                                    </div>

                                ))}

                            </div>

                        </div>

                        <img src={Images.PerfBackground} alt="" className="img-fluid w-100" />

                    </div>


                </div>

            </div>

            {/*  */}

            <div className="container-fluid" style={{margin: "20% 0"}}>
                <div className="row py-5">
                    <div className="col-md-8 text-center mx-auto">
                        <h4 className='text-primary fw-bold'>Step Spa - Recovery, Relaxation, and Rejuvenation</h4>
                        <p>Step Spa is a serene and purpose-built space within the Step Arena complex, dedicated to physical and mental regeneration. Tailored for athletes, wellness-seeking visitors, and anyone in need of personal care, it offers the ideal retreat to unwind, recharge, and restore balance.</p>
                        <p>Whether you’re an athlete recovering after intensive training, someone healing from an injury, or simply looking for a moment of tranquility, Step Spa is designed to support your wellbeing with expertise and care.</p>
                    </div>
                </div>

                <div className="row">

                    <div className="container-fluid p-0 position-relative">
                        

                        <div className="container position-absolute start-50 translate-middle-x icon-card">

                            <div className="row justify-content-center">

                                {PerformanceCards.map((item, index) => (

                                    <div key={index} className="col-3 d-flex flex-column align-items-center text-center">

                                        <div className="bg-white rounded w-100 h-100 shadow">
                                            <img src={item.image} alt="" className="img-fluid my-3" />
                                            <p className='text-primary'>Trainer</p>
                                        </div>

                                    </div>

                                ))}

                            </div>

                        </div>

                        <img src={Images.Relexation} alt="" className="img-fluid w-100" />

                    </div>


                </div>

            </div>
        </>
    )
}

export default RESTURANT
